var map = {
	"./icons/icon-bathroom.svg": "bc1c",
	"./icons/icon-bedroom.svg": "12e9",
	"./icons/icon-car.svg": "6531",
	"./icons/icon-carspace.svg": "dd6a",
	"./icons/icon-checkmark.svg": "9b69",
	"./icons/icon-circled-arrow.svg": "0674",
	"./icons/icon-clothing.svg": "3714",
	"./icons/icon-edit.svg": "140f",
	"./icons/icon-groceries.svg": "312f",
	"./icons/icon-holiday.svg": "05c4",
	"./icons/icon-housing.svg": "5f0c",
	"./icons/icon-location.svg": "e4d4",
	"./icons/icon-needle.svg": "1de0",
	"./icons/icon-other-costs.svg": "a493",
	"./icons/icon-social-life.svg": "44c7",
	"./icons/icon-star-empty.svg": "75a0",
	"./icons/icon-star-filled.svg": "90d5",
	"./icons/icon-tag.svg": "dc05",
	"./icons/icon-tooltip.svg": "b19c",
	"./logos/logo_cars-4-sale.svg": "30b5",
	"./logos/logo_fashion.svg": "3774",
	"./logos/logo_groceries.svg": "375f",
	"./logos/logo_grub-club.svg": "cb97",
	"./logos/logo_holidayhub.svg": "355f",
	"./logos/logo_nightlife.svg": "6511",
	"./logos/logo_other-costs.svg": "a93b",
	"./logos/logo_real-estate.svg": "2d00",
	"./logos/logo_welcome.svg": "772c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b8e";